<template>
  <div>
    <v-card 
      v-show="editMode"
      data-cy="dataset-dataformat-card-edit"
    >
      <v-card-title class="headline primary white--text">
        Data Formats
      </v-card-title>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex
            v-for="(item, ind) in dataset.dataset_data_format" 
            :key="ind"
          >
            <v-layout column align-center>
              <v-flex>
                <v-tooltip top>
                  <v-chip
                    slot="activator"
                    :close="true"
                    @input="removeDataFormat(item)"
                    :data-key="item.key"
                    :data-cy="item.dataformat_primary?'primary-data-format-chip-edit':''"
                  >
                    <v-avatar color="arbblue">
                    </v-avatar>
                    {{ item.data_format_cd }}
                  </v-chip>
                  <span>
                    {{ item.data_format_desc }}
                  </span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-speed-dial
          absolute
          open-on-hover
          right
        >
          <v-btn 
          color="primary"
          slot="activator"
          fab
          data-cy="dataformat-speeddial-btn"
          >
            <v-icon x-large>fa-plus-circle</v-icon>
          </v-btn>
        <v-chip 
            class="primary white--text"
            v-for="(dataformat, ind) in this.remainingDataFormats"
            :key="ind"
            @click="addDataFormat(dataformat)"
          >
          {{ dataformat.data_format_desc }}
        </v-chip>
      </v-speed-dial>
    </v-card-actions>
  </v-card>
    <v-card 
      v-show="!editMode"
      data-cy="dataset-dataformat-card-view">
      <v-card-title class="headline primary white--text">
          Data Formats
      </v-card-title>
      <v-card-actions>
        <v-layout row wrap>
          <v-flex>
             <v-tooltip        
                v-for="(item) in this.dataset.dataset_data_format"
                :key="item.key"
                top>
              <v-chip
                slot="activator"
                :class="{ presentation: getPresentMode }">
              <v-avatar color="arbblue">
              </v-avatar>
              {{ item.data_format_cd }}
              </v-chip>
              <span>{{ item.data_format_desc }}</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getPresentMode'
    ]),
    ...mapState({
      dataformats: state => state.dataset.transactions.allDataFormats
    }),
    dataset () {
      return this.getCurrentDataset
    },
    remainingDataFormats () {
      return this.dataformats ? this.dataformats.filter(item =>
        !this.dataset.dataset_data_format
          .some(dataformat => dataformat.data_format_cd === item.data_format_cd)
      ) : []
    }
  },
  methods: {
    ...mapActions([
      'removeItemAction',
      'addItemAction',
      'fetchAllDataFormatsAction'
    ]),
    removeDataFormat (dataformat) {
      const payload = {
        array: 'dataset_data_format',
        endpoint: 'dataformat',
        key: dataformat.key
      }
      this.removeItemAction(payload)
    },
    addDataFormat (dataformat) {
      const payload = {
        array: 'dataset_data_format',
        endpoint: 'dataformat',
        data: { ...dataformat }
      }
      this.addItemAction(payload)
    }
  },
  mounted () {
    this.fetchAllDataFormatsAction()
  }
}
</script>

<style scoped>
.svgIcon {
  fill: #ffffff;
  stroke: #ffffff;
}
</style>
